export default function Fleet() {
  return (
    <section id="fleet" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-8">
          <div className="lg:w-1/2">
            <div className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-3">OUR FLEET</div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              Executive Transportation<br />Redefined
            </h2>
          </div>
          <div className="lg:w-2/5">
            <p className="text-base lg:text-lg text-gray-600 leading-relaxed">
              Our premium Mercedes Maybach Sprinter vans combine luxury, comfort, and cutting-edge technology to deliver an unparalleled travel experience throughout Houston.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:scale-105">
            <div className="relative h-96 w-full">
              <img 
                src="https://public.readdy.ai/ai/img_res/2cef1c4c9b11fe5b8160831ed8edb49d.jpg" 
                alt="Executive Sprinter Interior"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              
              <div className="absolute top-6 left-6">
                <span className="inline-block bg-teal-500 text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-wide whitespace-nowrap">
                  Executive Class
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-bold mb-3">Spacious Executive Sprinter Vans</h3>
                <p className="text-sm text-gray-200 leading-relaxed mb-4">
                  Mercedes Maybach equipped with two TVs, Business WiFi, streaming capabilities, and ample luggage storage for ultimate comfort.
                </p>
                <div className="flex items-center space-x-4 text-xs">
                  <div className="flex items-center space-x-1">
                    <i className="ri-user-line"></i>
                    <span>10 Passengers</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-tv-line"></i>
                    <span>Dual TVs</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-wifi-line"></i>
                    <span>WiFi</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:scale-105">
            <div className="relative h-96 w-full">
              <img 
                src="https://readdy.ai/api/search-image?query=Luxurious%20Mercedes%20Maybach%20Sprinter%20van%20exterior%20side%20view%20showing%20sleek%20black%20finish%20with%20chrome%20details%2C%20parked%20at%20elegant%20hotel%20entrance%20with%20valet%20service%2C%20premium%20automotive%20photography%2C%20dramatic%20lighting%2C%20reflective%20surfaces%2C%20executive%20transportation%20vehicle%2C%20ultra%20high%20quality%20professional%20shot&width=600&height=800&seq=fleet-maybach-002&orientation=portrait" 
                alt="Mercedes Maybach Fleet"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              
              <div className="absolute top-6 left-6">
                <span className="inline-block bg-teal-500 text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-wide whitespace-nowrap">
                  Ultimate Luxury
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-bold mb-3">Brand New Mercedes Maybach Fleet</h3>
                <p className="text-sm text-gray-200 leading-relaxed mb-4">
                  Travel in style with our pristine Mercedes Maybach Luxury Sprinters. Experience the pinnacle of luxury transportation.
                </p>
                <div className="flex items-center space-x-4 text-xs">
                  <div className="flex items-center space-x-1">
                    <i className="ri-star-line"></i>
                    <span>Premium Amenities</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-shield-check-line"></i>
                    <span>Fully Insured</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-service-line"></i>
                    <span>Maintained</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:scale-105">
            <div className="relative h-96 w-full">
              <img 
                src="https://readdy.ai/api/search-image?query=Pristine%20white%20Mercedes%20Maybach%20Sprinter%20van%20exterior%20parked%20in%20front%20of%20modern%20Houston%20downtown%20skyline%2C%20professional%20corporate%20vehicle%2C%20sleek%20aerodynamic%20design%2C%20chrome%20accents%2C%20luxury%20transportation%2C%20golden%20hour%20lighting%2C%20architectural%20photography%2C%20ultra-sharp%20details%2C%20premium%20automotive%20shot&width=600&height=800&seq=fleet-exterior-001&orientation=portrait" 
                alt="Houston's Best Sprinter"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              
              <div className="absolute top-6 left-6">
                <span className="inline-block bg-teal-500 text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-wide whitespace-nowrap">
                  Houston's Best
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-bold mb-3">Premier Transportation Provider</h3>
                <p className="text-sm text-gray-200 leading-relaxed mb-4">
                  As Houston's premier luxury transportation provider, we're your go-to for corporate travel, vacations, and airport transfers.
                </p>
                <div className="flex items-center space-x-4 text-xs">
                  <div className="flex items-center space-x-1">
                    <i className="ri-map-pin-line"></i>
                    <span>Houston Area</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-time-line"></i>
                    <span>24/7 Available</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-customer-service-line"></i>
                    <span>Pro Drivers</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
